import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
};

const violationsTimeSlice = createSlice({
  name: 'aag/violationsTime',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

const { reducer: violationsTimeReducer, actions } = violationsTimeSlice;

export const violationsTimeActions = actions;
export default violationsTimeReducer;
